export const maskDecimal = (valor) => {
    const parsedValue = parseFloat(valor);
    return parsedValue?.toLocaleString("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        minimumIntegerDigits: 1,
        useGrouping: true,
    });
};
export const maskCNPJ = (str) => {
    let v = "";
    v = str.replace(/\D/g, "");

    if (v.length <= 11) {
        v = v.replace(/(\d{3})(\d)/, "$1.$2");
        v = v.replace(/(\d{3})(\d)/, "$1.$2");
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    } else {
        v = v.substring(0, 14); // limita em 14 números
        v = v.replace(/^(\d{2})(\d)/, "$1.$2");
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
        v = v.replace(/(\d{4})(\d)/, "$1-$2");
    }

    return v;
};
export const maskCEP = (str) => {
    let v = "";
    if (str) {
        v = str.replace(/\D/g, "");

        if (v.length) {
            v = v.substring(0, 8); // limita em 8 números
            v = v.replace(/^(\d{2})(\d)/, "$1.$2");
            v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2-$3");
        }
    }

    return v;
};
/**
 * Função para formatar o número decimal em tempo de digitação.
 * @param {string} numero - O número a ser formatado.
 * @returns {string} O número formatado.
 * @comentario Servi para mostrar ao usuário o número formatado
 */
export const formatarNumero = (valor) => {
    if (isNaN(valor)) {
        return;
    }

    const isNegative = Number(valor) < 0; // Verifica se o número é negativo
    const vr = valor.toString().replace(/\D/g, ""); // Remove todos os caracteres não numéricos
    const tam = vr.length;

    let formattedValue = "";

    if (tam <= 2) {
        formattedValue = vr;
    } else if (tam <= 5) {
        formattedValue = `${vr.substr(0, tam - 2)},${vr.substr(tam - 2)}`;
    } else if (tam <= 8) {
        formattedValue = `${vr.substr(0, tam - 5)}.${vr.substr(tam - 5, 3)},${vr.substr(tam - 2)}`;
    } else if (tam <= 11) {
        formattedValue = `${vr.substr(0, tam - 8)}.${vr.substr(tam - 8, 3)}.${vr.substr(tam - 5, 3)},${vr.substr(tam - 2)}`;
    } else if (tam <= 14) {
        formattedValue = `${vr.substr(0, tam - 11)}.${vr.substr(tam - 11, 3)}.${vr.substr(tam - 8, 3)}.${vr.substr(
            tam - 5,
            3
        )},${vr.substr(tam - 2)}`;
    } else if (tam <= 17) {
        formattedValue = `${vr.substr(0, tam - 14)}.${vr.substr(tam - 14, 3)}.${vr.substr(tam - 11, 3)}.${vr.substr(
            tam - 8,
            3
        )}.${vr.substr(tam - 5, 3)},${vr.substr(tam - 2)}`;
    } else {
        return valor; // Retorna o valor original se for muito grande
    }

    return isNegative ? `-${formattedValue}` : formattedValue; // Adiciona o sinal negativo se necessário
};

export const formatarNumero3Digitos = (valor) => {
    if (isNaN(valor)) return;

    const isNegative = Number(valor) < 0;
    const vr = valor.toString().replace(/\D/g, "");
    const tam = vr.length;

    let formattedValue = "";

    if (tam <= 3) {
        //formattedValue = `0,${vr.padStart(3, "0")}`;
        formattedValue = valor;
    } else if (tam <= 6) {
        formattedValue = `${vr.substr(0, tam - 3)},${vr.substr(tam - 3)}`;
    } else if (tam <= 9) {
        formattedValue = `${vr.substr(0, tam - 6)}.${vr.substr(tam - 6, 3)},${vr.substr(tam - 3)}`;
    } else if (tam <= 12) {
    } else if (tam <= 12) {
        formattedValue = `${vr.substr(0, tam - 9)}.${vr.substr(tam - 9, 3)}.${vr.substr(tam - 6, 3)},${vr.substr(tam - 3)}`;
    } else if (tam <= 9) {
    } else if (tam <= 15) {
        formattedValue = `${vr.substr(0, tam - 12)}.${vr.substr(tam - 12, 3)}.${vr.substr(tam - 9, 3)}.${vr.substr(
            tam - 6,
            3
        )},${vr.substr(tam - 3)}`;
    } else if (tam <= 9) {
    } else {
        return valor;
    }

    return isNegative ? `-${formattedValue}` : formattedValue;
};

/**
 *
 * @param {*} valor
 * @returns
 */
export const formatarNumeroDecimal = (valor) => {
    if (typeof valor !== "string") {
        valor = valor.toString();
    }

    // Permite apenas números e mantém o "-" no início
    const onlyNumbers = valor.replace(/[^\d-]/g, "");

    // Remove "-" se não estiver no início
    const sequencia = onlyNumbers.startsWith("-") ? "-" + onlyNumbers.slice(1).replace(/-/g, "") : onlyNumbers.replace(/-/g, "");

    // Se o número for muito curto, apenas retorna o que o usuário digitou
    if (sequencia.length < 3) return sequencia;

    // Obtém parte antes e depois das casas decimais
    let parte1 = sequencia.slice(0, -2); // Todos os caracteres, exceto os dois últimos
    let parte2 = sequencia.slice(-2); // Últimos dois caracteres

    // Se parte1 estiver vazia, retorna apenas os dois últimos caracteres com "0."
    return parte1 ? parte1 + "." + parte2 : "0." + parte2;
};

export const formatarNumeroDecimal3Digitos = (valor) => {
    if (!valor) return "";

    if (typeof valor !== "string") valor = valor.toString();

    const onlyNumbers = valor.replace(/[^\d-]/g, "");
    const sequencia = onlyNumbers.startsWith("-") ? "-" + onlyNumbers.slice(1).replace(/-/g, "") : onlyNumbers.replace(/-/g, "");

    if (sequencia.length === 0) return "";

    if (sequencia.length < 4) {
        return valor;
    }

    const parte1 = sequencia.slice(0, -3);
    const parte2 = sequencia.slice(-3);

    return parte1 ? parte1 + "." + parte2 : "0." + parte2;
};
/**
 *
 * @param {*} value valor a ser formatado
 * @param {*} formatador função que será aplicada
 * @returns esse código é para limpar a digitação na formatação de 3 digitos
 */
export const formatarOuVazio = (value, formatador) => {
    return value === "" ? "" : formatador(value);
};
/**
 * limita o texto recebendo o texto e o valor do limitador
 * @param {*} texto
 * @param {int} tamanho
 * @returns
 */
export const limitarTexto = (texto, tamanho) => {
    if (!tamanho) {
        tamanho = 15;
    }
    if (!texto) {
        return;
    }
    return texto.length > tamanho ? `${texto.substr(0, tamanho)}...` : texto;
};
// Converte "1.234,56" -> 1234.56  |  "28,96" -> 28.96  |  30 -> 30
export const toNumberBR = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return Number.isFinite(v) ? v : 0;
    const s = String(v).trim();
    if (!s) return 0;
    // remove espaços, tira separador de milhar ".", troca "," por "."
    const normalized = s.replace(/\s/g, "").replace(/\./g, "").replace(",", ".");
    const n = Number(normalized);
    return Number.isFinite(n) ? n : 0;
};

//mascara de codigo de conferencia
/**
 * Código de conferência (token) - formata em tempo de digitação.
 *
 * Exemplos:
 *  - "ab12cd34ef56" -> "AB12-CD34-EF56"  (grupo 4)
 *  - "123456"       -> "123-456"         (grupo 3)
 *
 * Opções:
 *  - groups: tamanhos de cada grupo
 *  - sep: separador entre grupos
 *  - maxLen: limite total (se omitido, soma dos groups)
 *  - allow: "alnum" | "numeric" | "alpha"
 */
export const maskConferenciaCodigo = (value, options = {}) => {
    const {
        groups = [4, 4, 4], // padrão: AAAA-BBBB-CCCC
        sep = "-",
        allow = "alnum",
        maxLen = groups.reduce((a, b) => a + b, 0),
    } = options;

    if (value == null) return "";

    // força string e caixa alta
    let v = String(value).toUpperCase();

    // remove separadores e espaços (deixa o usuário colar com "-" que a gente re-formata)
    v = v.replace(new RegExp(`[\\s${sep}]`, "g"), "");

    // filtra caracteres permitidos
    if (allow === "numeric") v = v.replace(/[^0-9]/g, "");
    else if (allow === "alpha") v = v.replace(/[^A-Z]/g, "");
    else v = v.replace(/[^A-Z0-9]/g, ""); // alnum

    // limita tamanho total
    v = v.slice(0, maxLen);

    // monta grupos
    const parts = [];
    let idx = 0;
    for (const size of groups) {
        if (idx >= v.length) break;
        parts.push(v.slice(idx, idx + size));
        idx += size;
    }

    return parts.join(sep);
};

/**
 * Remove a máscara e devolve o código "puro" (para salvar/validar).
 * "AB12-CD34" -> "AB12CD34"
 */
export const unmaskConferenciaCodigo = (value, options = {}) => {
    const { allow = "alnum" } = options;
    if (value == null) return "";

    let v = String(value).toUpperCase().replace(/\s/g, "");

    if (allow === "numeric") v = v.replace(/[^0-9]/g, "");
    else if (allow === "alpha") v = v.replace(/[^A-Z]/g, "");
    else v = v.replace(/[^A-Z0-9]/g, "");

    return v;
};

/**
 * Valida se o código está completo (tamanho exato) conforme o padrão.
 * Ex: groups [4,4,4] => precisa ter 12 chars "puros".
 */
export const isConferenciaCodigoCompleto = (value, options = {}) => {
    const { groups = [4, 4, 4], allow = "alnum" } = options;

    const maxLen = groups.reduce((a, b) => a + b, 0);
    const raw = unmaskConferenciaCodigo(value, { allow });
    return raw.length === maxLen;
};

const objetoDeFuncoes = {
    maskDecimal,
    maskCNPJ,
    maskCEP,
    formatarNumero,
    formatarNumero3Digitos,
    formatarNumeroDecimal,
    formatarNumeroDecimal3Digitos,
    formatarOuVazio,
    toNumberBR,
    //mascara do código de conferencia
    maskConferenciaCodigo,
    unmaskConferenciaCodigo,
    isConferenciaCodigoCompleto,
};

export default objetoDeFuncoes;
